import { StoreDetailsPageTranslations } from "~/bff/types/StoreDetailsPageTranslations";

export const getLocalizedDaysText = (
  translations?: StoreDetailsPageTranslations,
): {
  sunday: string;
  monday: string;
  tuesday: string;
  wednesday: string;
  thursday: string;
  friday: string;
  saturday: string;
} => ({
  sunday: translations?.sundayText ?? "",
  monday: translations?.mondayText ?? "",
  tuesday: translations?.tuesdayText ?? "",
  wednesday: translations?.wednesdayText ?? "",
  thursday: translations?.thursdayText ?? "",
  friday: translations?.fridayText ?? "",
  saturday: translations?.saturdayText ?? "",
});
